var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertErrorYellow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 21.141 21.141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "circle-xmark-solid",
    d: "M10.57,21.141A10.57,10.57,0,1,0,0,10.57,10.57,10.57,0,0,0,10.57,21.141ZM7.226,7.226a.987.987,0,0,1,1.4,0l1.941,1.941,1.941-1.941a.99.99,0,1,1,1.4,1.4l-1.941,1.941,1.941,1.941a.99.99,0,1,1-1.4,1.4l-1.941-1.941L8.626,13.907a.99.99,0,1,1-1.4-1.4l1.941-1.941L7.226,8.626A.987.987,0,0,1,7.226,7.226Z",
    fill: "#AD8334"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertErrorYellow);
export default __webpack_public_path__ + "static/media/alertErrorYellow.51deff5db841121fb09150ad3f986fcf.svg";
export { ForwardRef as ReactComponent };